import itemSelectorSingle from './itemSelectorSingle';

export default itemSelectorSingle;